import { EventDetailsStyles } from './EventDetails.types'

const makeStyles = (): EventDetailsStyles => ({
	zeroMargin: {
		margin: 0
	}
})

export default makeStyles
